module.exports = __webpack_public_path__ + "img/stitching-fairy-MacBook-Pro-mockup-front-page.5ce47775.jpg";